import childWelcome from "./assets/journey-v7/poses/child-welcome.webp";
import childListening from "./assets/journey-v7/poses/child-listening.webp";
import childRecitation from "./assets/journey-v7/poses/child-recitation.webp";
import childUnderstanding from "./assets/journey-v7/poses/child-understanding.webp";
import childProgression from "./assets/journey-v7/poses/child-progression.webp";
import beginnerWelcome from "./assets/journey-v7/poses/beginner-welcome.webp";
import beginnerListening from "./assets/journey-v7/poses/beginner-listening.webp";
import beginnerRecitation from "./assets/journey-v7/poses/beginner-recitation.webp";
import beginnerUnderstanding from "./assets/journey-v7/poses/beginner-understanding.webp";
import beginnerProgression from "./assets/journey-v7/poses/beginner-progression.webp";
import confirmedWelcome from "./assets/journey-v7/poses/confirmed-welcome.webp";
import confirmedListening from "./assets/journey-v7/poses/confirmed-listening.webp";
import confirmedRecitation from "./assets/journey-v7/poses/confirmed-recitation.webp";
import confirmedUnderstanding from "./assets/journey-v7/poses/confirmed-understanding.webp";
import confirmedProgression from "./assets/journey-v7/poses/confirmed-progression.webp";
import adultWelcome from "./assets/journey-v7/poses/adult-welcome.webp";
import adultListening from "./assets/journey-v7/poses/adult-listening.webp";
import adultRecitation from "./assets/journey-v7/poses/adult-recitation.webp";
import adultUnderstanding from "./assets/journey-v7/poses/adult-understanding.webp";
import adultProgression from "./assets/journey-v7/poses/adult-progression.webp";
import professorWelcome from "./assets/journey-v7/poses/professor-welcome.webp";
import professorListening from "./assets/journey-v7/poses/professor-listening.webp";
import professorRecitation from "./assets/journey-v7/poses/professor-recitation.webp";
import professorUnderstanding from "./assets/journey-v7/poses/professor-understanding.webp";
import professorProgression from "./assets/journey-v7/poses/professor-progression.webp";
import childListeningScene from "./assets/journey-v7/scenes/child-listening.webp";
import childRecitationScene from "./assets/journey-v7/scenes/child-recitation.webp";
import childProgressionScene from "./assets/journey-v7/scenes/child-progression.webp";
import beginnerListeningScene from "./assets/journey-v7/scenes/beginner-listening.webp";
import beginnerRecitationScene from "./assets/journey-v7/scenes/beginner-recitation.webp";
import beginnerProgressionScene from "./assets/journey-v7/scenes/beginner-progression.webp";
import confirmedListeningScene from "./assets/journey-v7/scenes/confirmed-listening.webp";
import confirmedRecitationScene from "./assets/journey-v7/scenes/confirmed-recitation.webp";
import confirmedProgressionScene from "./assets/journey-v7/scenes/confirmed-progression.webp";
import adultListeningScene from "./assets/journey-v7/scenes/adult-listening.webp";
import adultRecitationScene from "./assets/journey-v7/scenes/adult-recitation.webp";
import adultProgressionScene from "./assets/journey-v7/scenes/adult-progression.webp";
import professorListeningScene from "./assets/journey-v7/scenes/professor-listening.webp";
import professorRecitationScene from "./assets/journey-v7/scenes/professor-recitation.webp";
import professorProgressionScene from "./assets/journey-v7/scenes/professor-progression.webp";
import reward1 from "./assets/journey-v7/rewards/premier-pas.webp";
import reward2 from "./assets/journey-v7/rewards/ecoute-attentive.webp";
import reward3 from "./assets/journey-v7/rewards/recitation-complete.webp";
import reward4 from "./assets/journey-v7/rewards/regle-comprise.webp";
import reward5 from "./assets/journey-v7/rewards/memoire-en-progres.webp";
import reward6 from "./assets/journey-v7/rewards/serie-sept-jours.webp";
import reward7 from "./assets/journey-v7/rewards/objectif-atteint.webp";
import reward8 from "./assets/journey-v7/rewards/transmission-savoir.webp";
import reward9 from "./assets/journey-v7/rewards/signal-exploitable.webp";
import reward10 from "./assets/journey-v7/rewards/reflexion-suivante.webp";

const PROFILE_KEYS = { teacher: "professor" };

const pose = {
  child: { welcome: childWelcome, listening: childListening, recitation: childRecitation, understanding: childUnderstanding, progression: childProgression },
  beginner: { welcome: beginnerWelcome, listening: beginnerListening, recitation: beginnerRecitation, understanding: beginnerUnderstanding, progression: beginnerProgression },
  confirmed: { welcome: confirmedWelcome, listening: confirmedListening, recitation: confirmedRecitation, understanding: confirmedUnderstanding, progression: confirmedProgression },
  adult: { welcome: adultWelcome, listening: adultListening, recitation: adultRecitation, understanding: adultUnderstanding, progression: adultProgression },
  professor: { welcome: professorWelcome, listening: professorListening, recitation: professorRecitation, understanding: professorUnderstanding, progression: professorProgression },
};

const scene = {
  child: { listening: childListeningScene, recitation: childRecitationScene, progression: childProgressionScene },
  beginner: { listening: beginnerListeningScene, recitation: beginnerRecitationScene, progression: beginnerProgressionScene },
  confirmed: { listening: confirmedListeningScene, recitation: confirmedRecitationScene, progression: confirmedProgressionScene },
  adult: { listening: adultListeningScene, recitation: adultRecitationScene, progression: adultProgressionScene },
  professor: { listening: professorListeningScene, recitation: professorRecitationScene, progression: professorProgressionScene },
};

export const JOURNEY_REWARDS = [reward1, reward2, reward3, reward4, reward5, reward6, reward7, reward8, reward9, reward10];

const REWARDS_BY_PROFILE = {
  child: [reward1, reward2, reward3, reward4, reward6],
  beginner: [reward1, reward2, reward4, reward3, reward7],
  adult: [reward2, reward9, reward3, reward7, reward10],
  confirmed: [reward9, reward4, reward5, reward7, reward10],
  professor: [reward8, reward9, reward4, reward7, reward10],
};

export function journeyRewards(profile) {
  const key = PROFILE_KEYS[profile] || profile;
  return REWARDS_BY_PROFILE[key] || JOURNEY_REWARDS.slice(0, 5);
}

export function journeyVisuals(profile) {
  const key = PROFILE_KEYS[profile] || profile;
  return pose[key] ? { profile: key, poses: pose[key], scenes: scene[key] } : null;
}

export const JOURNEY_WELCOME_ART = Object.fromEntries(
  Object.keys(pose).map((key) => [key === "professor" ? "teacher" : key, pose[key].welcome]),
);

